import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { PropType } from 'vue';
  import type { RouteLocationRaw } from 'vue-router';
  import IconArrowUpRightFromSquare from '@/icons/IconArrowUpRightFromSquare.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BaseLink',
  props: {
    to: {
      type: [String, Object] as PropType<RouteLocationRaw>,
      required: true,
    },
    isOpenInNewTab: {
      type: Boolean as PropType<boolean>,
      default: true,
    }
  },
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    to: __props.to,
    class: "font-medium text-primary hover:underline",
    target: __props.isOpenInNewTab ? '_blank' : '_self',
    rel: "noreferrer"
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default"),
      (__props.isOpenInNewTab)
        ? (_openBlock(), _createBlock(IconArrowUpRightFromSquare, {
            key: 0,
            class: "ml-1 inline-block h-4 w-4 align-baseline color-primary",
            fill: "currentColor"
          }))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["to", "target"]))
}
}

})